/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useContext, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { Button, Heading, ModalContext } from 'school-space-client/components';

import { openRecurringSpaceBookingModal } from '../../recurringBooking/modals';

import RecurringBookingSpaces from '../../recurringBooking/RecurringBookingSpaces';
import css from './css';

const ReviewSpaces = ({
    recurringBooking,
    refetchBooking,
    confirmStep,
    stepIsConfirmed,
    stepIsVisible
}) => {
    const modalProps = useContext(ModalContext);
    const ref = useRef(null);

    useEffect(() => {
        if (stepIsVisible) {
            ref.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }
    }, [stepIsVisible]);

    const addSpace = () =>
        openRecurringSpaceBookingModal({
            ...modalProps,
            recurringBooking,
            refetchBooking
        });

    return (
        <div ref={ref}>
            {!stepIsConfirmed && (
                <Heading level="2" size="medium" styles={css.heading}>
                    2. Review spaces and times
                </Heading>
            )}
            {stepIsVisible && (
                <div css={css.content}>
                    <RecurringBookingSpaces
                        recurringBooking={recurringBooking}
                        refetchBooking={refetchBooking}
                        spacesAreEditable
                    />
                    <div css={css.actionButtons}>
                        <Button
                            state="ghost"
                            styles={css.actionButton}
                            size="small"
                            onClick={addSpace}
                        >
                            Add space
                        </Button>
                        {!stepIsConfirmed && (
                            <Button styles={css.actionButton} size="small" onClick={confirmStep}>
                                Confirm spaces
                            </Button>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

ReviewSpaces.propTypes = {
    recurringBooking: PropTypes.objectOf(PropTypes.any).isRequired,
    refetchBooking: PropTypes.func.isRequired,
    confirmStep: PropTypes.func.isRequired,
    stepIsConfirmed: PropTypes.bool.isRequired,
    stepIsVisible: PropTypes.bool.isRequired
};

export default ReviewSpaces;
